"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.024 20.973A5 5 0 0 1 14.5 21h-6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h7c2.21 0 4 1.79 4 3.999V16q0 .202-.016.4a5 5 0 0 1-4.46 4.573M18.1 15V6.999A2.6 2.6 0 0 0 15.5 4.4h-7A2.6 2.6 0 0 0 5.9 7v10a2.6 2.6 0 0 0 2.6 2.6h5.124v-1.9a2.7 2.7 0 0 1 2.7-2.7zm-3.077 4.562V17.7a1.3 1.3 0 0 1 1.3-1.3h1.755a3.6 3.6 0 0 1-3.054 3.162",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.9 9.943v3.704l2.897-1.834.003-.019-.002-.017zm.666-1.235c-.978-.62-2.066.19-2.066 1.197v3.78c0 1.009 1.09 1.814 2.066 1.197l2.987-1.89c.862-.548.864-1.847-.001-2.394z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=VideoFileIcon24.js.map